import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxState } from "../redux-store";

export interface ProgressBarState {
	progress: number | undefined;
}

const initialState: ProgressBarState = {
	progress: 0,
};

const progressBarSlice = createSlice({
	name: "progressBar",
	initialState,
	reducers: {
		updateProgress: (state, action: PayloadAction<number | undefined>) => {
			state.progress = action.payload;
		},
		resetProgress: (state) => {
			state.progress = 0;
		},
	},
});

export const { updateProgress, resetProgress } = progressBarSlice.actions;

export const ProgressBarReducer = progressBarSlice.reducer;

export const selectProgressBar = (state: ReduxState) => state.progressBar.progress;
